import { createContext, useContext } from 'react';

export interface CatalogBrandContextValue {
  /**
   * The brand every catalog call must be scoped to, as the brand's
   * `snowflakeIdNum` — that is the key `BrandAccessService.verifyBrandAccess`
   * uses to resolve an admin's `adminBrandId`, NOT `Brand.id`.
   *
   * `undefined` for brand users: the server resolves their own brand and
   * ignores any input, so their calls stay byte-identical to before. For an
   * admin it is always a number — `CatalogRoute` refuses to render the catalog
   * until one is selected, because an admin call with no brandId lands in the
   * shared `'admin'` bucket (`catalog.router.ts` resolveBrandKey).
   */
  brandId: number | undefined;
}

export const CatalogBrandContext = createContext<CatalogBrandContextValue>({ brandId: undefined });

/** The brandId to put on a catalog tRPC input. `undefined` outside the admin gate. */
export const useCatalogBrandId = (): number | undefined => useContext(CatalogBrandContext).brandId;
